export function isDefined<T>(value: T | undefined | null): value is T {
  return value !== undefined && value !== null
}

export function isAllDefined<T>(value: (T | undefined | null)[]): value is T[] {
  return value.every(isDefined)
}

export function isPopulatedList<T>(value: T[] | undefined | null): value is [T, ...T[]] {
  return isDefined(value) && value.length > 0
}
